import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useDeviceStore = create(
  persist(
    (set) => ({

      devices: [],
      setDevices: (data) => set({ devices: data }),
      lastQuery: "",
      setLastQuery: (query) => set({ lastQuery: query }),

      selectedDevices: [],

      toggleDevice: (device) =>
        set((state) => {
          const exists = state.selectedDevices.find(
            (d) => d.id === device.id
          );

          if (exists) {
            return {
              selectedDevices: state.selectedDevices.filter(
                (d) => d.id !== device.id
              ),
            };
          }

          if (state.selectedDevices.length >= 2) return state;

          return {
            selectedDevices: [...state.selectedDevices, device],
          };
        }),

      clearSelection: () => set({ selectedDevices: [] }),
    }),
    {
      name: "device-storage", // key in localStorage
      partialize: (state) => ({
        devices: state.devices,
        selectedDevices: state.selectedDevices,
        lastQuery: state.lastQuery,
      }),
    }
  )
);